import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { submitFundingStateRoutineWithPayload } from 'actions/routines/external';
import { updatePaymentMethodFormFields } from 'constants/formFields';
import { formNamesExternal } from 'constants/forms';
import { getItemKindFromExternalPath } from 'helpers/external';
import { getFundingAccountPaymentDeliveryMethod } from 'helpers/funding';
import { useFieldValue, useSelectorWithProps } from 'hooks';
import { fundingAccountForIdSelector } from 'selectors/fundingSelectors';
export const useSubmitReceivablePaymentMethod = ({ isFormValid = true }) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const selectedFundingAccountId = useFieldValue(formNamesExternal.UPDATE_PAYMENT_METHOD, updatePaymentMethodFormFields.FUNDING_ACCOUNT);
    const selectedFundingAccount = useSelectorWithProps(fundingAccountForIdSelector, selectedFundingAccountId);
    return async (values) => {
        if (!isFormValid) {
            return;
        }
        const paymentDeliveryMethod = getFundingAccountPaymentDeliveryMethod(selectedFundingAccount);
        dispatch(submitFundingStateRoutineWithPayload({
            defaultReceivable: { ...values.defaultReceivable, paymentDeliveryMethod },
            itemKind: getItemKindFromExternalPath(location),
        }));
    };
};
